define('ShopByModel.Thumbnail.View', [
  'Backbone',
  'SCView',
  'shop_by_model_thumbnail.tpl'
], function (
  Backbone,
  SCViewModule,
  gofer_model_thumbnail_tpl
) {
  'use strict';

  var SCView = SCViewModule.SCView;

  function GoferModelThumbnailView(options) {
    SCView.call(this, options);

    this.model = options.model;

    this.template = gofer_model_thumbnail_tpl;
  }

  GoferModelThumbnailView.prototype = Object.create(SCView.prototype);
  GoferModelThumbnailView.prototype.constructor = GoferModelThumbnailView;

  GoferModelThumbnailView.prototype.getContext = function () {
    var isLocal = window.location.href.indexOf('-local.ssp') !== -1;
    var localPath = Backbone.history.location.hash;
    var path = Backbone.history.location.pathname;
    var gfrModel = this.model.get('model')||{};
  
    var isDocuments = false
    ,   isDiagrams = false
    ,   isVideos = false
    ,   isParts = false;

    var href = window.location.href;
    
    if ( href.indexOf('documents') !== -1 ) {
      isDocuments = true;
    } else if ( href.indexOf('diagrams') !== -1 ) {
      isDiagrams = true;
    } else if ( href.indexOf('videos') !== -1 ) {
      isVideos = true;
    } else{
      isParts = true;
    }

    return {
      model: this.model,
      image: gfrModel.image,
      name: gfrModel.name,
      parentModel: gfrModel.parentModel,
      type: gfrModel.type,
      value: gfrModel.value,
      modelUrl: isLocal ? localPath : path,
      isDocuments: isDocuments,
      isDiagrams: isDiagrams,
      isVideos: isVideos,
      isParts: isParts
    };
  };

  return GoferModelThumbnailView;
});
